import { ROUTE_TEXT_MATERIALS_THEMES } from '@@partner:config/routes'
import TextMaterialThemeForm from '@components/textMaterials/theme/TextMaterialThemeForm'
import React from 'react'
import { ArrowBackOutline } from 'react-ionicons'
import { generatePath, NavLink, useParams } from 'react-router-dom'
import { Nav, Navbar } from 'rsuite'

export default function TextMaterialThemeFormPage () {
  const { themeId, brandSlug } = useParams<any>()

  return (
    <div className="CustomerFormPage">
      <h1 className="u-heading">
        {themeId ? 'Редактирование' : 'Добавление'} темы
      </h1>
      <Navbar appearance='subtle'>
        <Nav>
          <Nav.Item
            icon={<ArrowBackOutline />}
            as={NavLink}
            to={generatePath(ROUTE_TEXT_MATERIALS_THEMES, {
              brandSlug
            })}
          >
             Вернуться к списку
          </Nav.Item>
        </Nav>
      </Navbar>
      <TextMaterialThemeForm themeId={themeId} />
    </div>
  )
}